// src/context/BackgroundImageContext.js
import React, { createContext, useState, useEffect, useContext } from 'react';

const BackgroundImageContext = createContext(undefined);

export const BackgroundImageProvider = ({ children }) => {
  const [isBackgroundImageVisible, setIsBackgroundImageVisible] = useState(() => {
    const storedPreference = localStorage.getItem('backgroundImageVisible');
    // Default to true (image visible) if no preference is stored
    return storedPreference !== null ? JSON.parse(storedPreference) : true;
  });

  useEffect(() => {
    localStorage.setItem('backgroundImageVisible', JSON.stringify(isBackgroundImageVisible));
  }, [isBackgroundImageVisible]);

  const toggleBackgroundImage = () => {
    setIsBackgroundImageVisible(prev => !prev);
  };

  return (
    <BackgroundImageContext.Provider value={{ isBackgroundImageVisible, toggleBackgroundImage }}>
      {children}
    </BackgroundImageContext.Provider>
  );
};

export const useBackgroundImage = () => {
  const context = useContext(BackgroundImageContext);
  if (context === undefined) {
    throw new Error('useBackgroundImage must be used within a BackgroundImageProvider');
  }
  return context;
};